export interface PageSelectableNode {
  rowIndex: number | null
  detail?: boolean
  data?: unknown
  isSelected?: () => boolean | undefined
}

export function nodesOnPage<T extends PageSelectableNode>(
  nodes: T[],
  page: number,
  pageSize: number,
): T[] {
  const start = page * pageSize
  const end = start + pageSize
  return nodes.filter(
    (node) =>
      !node.detail &&
      node.data != null &&
      node.rowIndex != null &&
      node.rowIndex >= start &&
      node.rowIndex < end,
  )
}

export function allNodesSelected(nodes: PageSelectableNode[]): boolean {
  return nodes.length > 0 && nodes.every((node) => node.isSelected?.() === true)
}
